
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * StorageDatabaseType enum
 */
class StorageDatabaseType {
  /**
   * Initialize enum with a given value
   * @param {StorageDatabaseType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof StorageDatabaseType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!StorageDatabaseType}
   * @param {!StorageDatabaseType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof StorageDatabaseType)) {
      throw new TypeError('Instance of StorageDatabaseType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!StorageDatabaseType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!StorageDatabaseType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === StorageDatabaseType.MEMORY.value) {
      return 'MEMORY'
    }
    if (this.value === StorageDatabaseType.SQLITE.value) {
      return 'SQLITE'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!StorageDatabaseType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!StorageDatabaseType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!StorageDatabaseType} Created enum
   */
  static fromObject (other) {
    return new StorageDatabaseType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
StorageDatabaseType.MEMORY = new StorageDatabaseType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
StorageDatabaseType.SQLITE = new StorageDatabaseType(0 + 1)

export { StorageDatabaseType };

/**
 * Fast Binary Encoding StorageDatabaseType field model
 */
class FieldModelStorageDatabaseType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelStorageDatabaseType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the value
   * @this {!FieldModelStorageDatabaseType}
   * @param {StorageDatabaseType=} defaults Default value, defaults is new StorageDatabaseType()
   * @returns {!StorageDatabaseType} Result value
   */
  get (defaults = new StorageDatabaseType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new StorageDatabaseType(this.readInt32(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelStorageDatabaseType}
   * @param {!StorageDatabaseType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeInt32(this.fbeOffset, value.value)
  }
}

export { FieldModelStorageDatabaseType };
